import React from "react";
import PropTypes from "prop-types";
import { Navigation, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import SliderItem from "./slider-item";
import "swiper/scss";
import "swiper/scss/navigation";
import "swiper/scss/pagination";
import "./styles.scss";

Slider.propTypes = {
  data: PropTypes.array,
};

function Slider(props) {
  const { data } = props;
  return (
    <section id="asosiy" className="slider">
      <Swiper
        modules={[Navigation, Scrollbar, A11y]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        scrollbar={{ draggable: true }}
      >
        {data.map((item, index) => (
          <SwiperSlide key={item.id}>
            {/* Faqat birinchi slayd sahifaning yagona h1'i bo'ladi */}
            <SliderItem item={item} index={index} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default Slider;
